module.exports = __webpack_public_path__ + "media/components/resources/show/resource-show-main/img/ellipsis-5bec3618f00f56afa64f5481d0eec651.png";